import React from 'react'
import logo from '@/assets/branding/fav.svg'
import CircularProgress from '@/components/ui/circular-progress-bar'
import { getPerformanceRatingStyle, getRatingText } from '../utils/rating'

interface RatingProps {
    rating: number;
    title: string;
}

const Rating: React.FC<RatingProps> = ({ rating, title }) => {
    // Convert rating to percent for the progress bar (assuming out of 10)
    const progress = Math.round((rating / 10) * 100);
    const ratingText = getRatingText(rating);
    const ratingStyle = getPerformanceRatingStyle(ratingText);
    const chipBaseClass = 'px-2 py-0.5 rounded-[5px] text-[12px] leading-4 font-medium';

    return (
        <div className="flex items-center gap-3">
            {/* Circular progress with logo in center */}
            <div className="relative flex items-center justify-center" style={{ width: 50, height: 50 }}>
                <CircularProgress progress={progress} size={50} strokeWidth={5} showText={false} />
                <img src={logo} alt="logo" className="absolute w-7 h-7" style={{ left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }} />
            </div>
            <div className="flex flex-col justify-center gap-1">
                <div className='flex flex-row items-center gap-2'>
                    <div className='flex flex-row items-center gap-0.5'>
                        <span className="font-ubuntu text-[20px] leading-[26px] font-medium text-black">{rating}
                        </span>
                        <span className="text-grey-6 font-ubuntu text-[20px] leading-[26px] font-medium opacity-50">/10</span>
                    </div>

                </div>
                <span className="font-dm-sans text-[14px] leading-[22px] font-normal text-grey-6 tracking-[0.07px]">{title}</span>
            </div>
        </div>
    )
}

export default Rating